import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import modules from './modules'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
	key: 'vuex',
	storage: window.localStorage,
	reducer: state => ({
		User: state.User
	})
	// Function that passes a mutation and lets you decide if it should update the state in localStorage.
	// filter: mutation => (true)
})

export default new Store({
	modules,
	plugins: [vuexLocalStorage.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js